<script>
// import axios from '@/utils/axios';
import { useLeadMetaStore } from '@/stores/useLeadMetaStore'

export default {
inject: ['setLoading'],    
 data() {
  return { 
   title: "Settings",
   text: "Administration",
   text1: "Settings",
  //  data: [],
   searchText: '',
   columns: [
      {
        title: 'S.No',
        dataIndex: 'SNo',
        key: 'SNo',
      },
      {
        title: 'Stage Name',
        dataIndex: 'StageName',
        key: 'StageName',
      },
      {
        title: 'Stage Order',
        dataIndex: 'StageOrder',
        key: 'StageOrder',
      },
      {
        title: 'Actions',
        key: 'action',
      },
    ],
    rowSelection: null,
  };
},

//  computed: {
//   filteredData() {
//     if (!this.searchText) return this.data;
//     const search = this.searchText.toLowerCase();
//     return this.data.filter(item => item.name?.toLowerCase().includes(search));
//   },
//  },

computed: {
  stageList() {
    return useLeadMetaStore().stages || [];
  },
  filteredData() {
    if (!this.searchText) return this.stageList;
    const search = this.searchText.toLowerCase();
    return this.stageList.filter(item => item.name?.toLowerCase().includes(search));
  },
},

//  mounted() {
//   this.stages();
//  }, 

async mounted() {
  const store = useLeadMetaStore();
  if (!store.stages.length) {
    this.setLoading(true);
    try { await store.refreshStages(); }
    finally { this.setLoading(false); }
  }
},

 methods: {

  // async stages(){
  //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('/lead-stages');
  //   this.data = response.data.data;
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  }
  // }

  async onStageUpdated() {
    await useLeadMetaStore().refreshStages();
  },

 },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="head-icons ms-2">
     
    </div>
  </div>
  <!-- /Breadcrumb -->

 <settings-tab></settings-tab>
  <div class="row">
 <crm-sidebar></crm-sidebar>
<div class="col-xl-9">
<div class="card">
<div class="card-body">
<div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
<h4>Lead Stages</h4>
<div>
<a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#stage_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.stageModal.add();"><i class="ti ti-circle-plus me-2"></i>Add Stage</a>
</div>
</div>
<div class="card-body p-0">
<div class="card mb-0">
<div class="card-header d-flex align-items-center justify-content-between">
<a-input v-model:value="searchText" placeholder="Search stage name..." allow-clear style="width: 300px;"/>
</div>
<div class="custom-datatable-filter table-responsive">

<a-table v-if="filteredData.length" class="table datatable thead-light" :columns="columns" :data-source="filteredData"
  :row-selection="rowSelection">
  <template #bodyCell="{ column, record, index }">
    <template v-if="column.key === 'SNo'"> {{ index + 1 }}. </template>   
    <template v-if="column.key === 'StageName'">
      <h6 class="fs-14 fw-medium">
        <i class="ti ti-circle-filled" :style="{ color: record.color || '#6c757d', marginRight: '6px' }"></i>
        <router-link to="#">{{ record.name }}</router-link>
      </h6>
    </template>
    <template v-if="column.key === 'StageOrder'">
      <h6 class="fs-14 fw-medium">
        <router-link to="#">{{ record.order_by }}</router-link>
      </h6>
    </template>
    <template v-if="column.key === 'action'">
      <div class="action-icon d-inline-flex">
        <a href="javascript:void(0);" class="me-2" data-bs-toggle="modal" data-bs-target="#stage_modal" @click="$refs.stageModal.editStage(record)">
          <i class="ti ti-edit"></i>
        </a>
        <a href="javascript:void(0);" class="text-danger" data-bs-toggle="modal" data-bs-target="#delete_modal" @click="$refs.stageModal.editStage(record)">
          <i class="ti ti-trash"></i>
        </a>
      </div>
    </template>
  </template>
</a-table>

<div v-else class="p-3 text-center text-muted">
  No records found.
</div>

</div>
  </div>
</div>
</div>
</div>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->
<!-- <lead-stage-modal ref="stageModal" @updated="stages"></lead-stage-modal> -->

 <lead-stage-modal ref="stageModal" @updated="onStageUpdated"></lead-stage-modal>
</template>
